import { Box } from '@chakra-ui/react';

const Container = ({ children, ...props }) => {
  return (
    <Box maxW={['428px', '428px', '1440px']} mx={'auto'} px={['12px', '16px', '36px', '83px']} {...props}>
      {children}
    </Box>
  );
};
export default Container;